export default "__VITE_ASSET__21cea683__"